import { GlCollapsibleListbox, GlTooltip, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../alert.js?vue3';
import { TYPE_INCIDENT } from '~/issues/constants';
import SidebarEditableItem from '../sidebar_editable_item.vue?vue3';
import updateIssuableSeverity from '../../queries/update_issuable_severity.mutation.graphql';
import { INCIDENT_SEVERITY, SEVERITY_I18N as I18N } from '../../constants';
import SeverityToken from './severity.vue?vue3';
export default {
    name: 'SidebarSeverityWidget',
    i18n: I18N,
    components: {
        GlTooltip,
        GlSprintf,
        GlCollapsibleListbox,
        SeverityToken,
        SidebarEditableItem
    },
    inject: [
        'canUpdate'
    ],
    props: {
        projectPath: {
            type: String,
            required: true
        },
        iid: {
            type: String,
            required: true
        },
        initialSeverity: {
            type: String,
            required: false,
            default: INCIDENT_SEVERITY.UNKNOWN.value
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_INCIDENT,
            validator: (value)=>{
                // currently severity is supported only for incidents, but this list might be extended
                return [
                    TYPE_INCIDENT
                ].includes(value);
            }
        }
    },
    data () {
        return {
            isUpdating: false,
            severity: this.initialSeverity
        };
    },
    computed: {
        severitiesList () {
            switch(this.issuableType){
                case TYPE_INCIDENT:
                    return Object.values(INCIDENT_SEVERITY);
                default:
                    return [];
            }
        },
        dropdownItems () {
            return this.severitiesList.map((severity)=>({
                    text: severity.label,
                    value: severity.value,
                    severity
                }));
        },
        selectedItem () {
            return this.severitiesList.find((severity)=>severity.value === this.severity);
        }
    },
    methods: {
        updateSeverity (value) {
            this.$refs.toggle.collapse();
            this.isUpdating = true;
            this.$apollo.mutate({
                mutation: updateIssuableSeverity,
                variables: {
                    iid: this.iid,
                    severity: value,
                    projectPath: this.projectPath
                }
            }).then((resp)=>{
                const { data: { issueSetSeverity: { errors = [], issue: { severity } } } } = resp;
                if (errors[0]) {
                    throw errors[0];
                }
                this.severity = severity;
            }).catch(()=>createAlert({
                    message: `${this.$options.i18n.UPDATE_SEVERITY_ERROR} ${this.$options.i18n.TRY_AGAIN}`
                })).finally(()=>{
                this.isUpdating = false;
            });
        },
        showDropdown () {
            this.$refs.dropdown.open();
        }
    }
};
